// Les problèmes de précision dus au format flottant sont de vrais Pain au cul !
// Voir https://floating-point-gui.de/basic/
// > 11 * 1609.34 => 17702.739999999998
// > 11 * (160934 / 100) => 17702.74

function safeDivide(a: number, b: number) {
  // Le facteur par lequel nous allons multiplier pour travailler avec des entiers
  // On ne devrait pas avoir plus de 5 nombres après la virgule.
  const factor = 10e6;

  // On transforme nos nombres en entiers.
  // L'utilisation de Math.round évite les imprécisions restantes du format flottant.
  const intA = Math.round(a * factor);
  const intB = Math.round(b * factor);

  // Pour la division, on peut multiplier le numérateur par le facteur
  // pour conserver la précision, puis diviser les deux entiers.
  const result = (intA * factor) / intB;

  // Et enfin, on redéplace la virgule.
  return result / factor;
}

const round = (n: number, p: number) => Number(n.toFixed(p));

export const milesToMeters = (miles: number) => round((miles * 160934) / 100, 2);
export const metersToMiles = (meters: number) => round(safeDivide(meters * 100, 160934), 5);
